export function ToolSkeleton() {
  return (
    <div className="space-y-3" aria-busy="true" aria-label="Loading tool">
      {[0, 1, 2].map((i) => (
        <div
          key={i}
          className="animate-shimmer relative overflow-hidden rounded-3xl border border-hairline bg-surface"
          style={{ height: i === 0 ? 96 : 128 }}
        />
      ))}
    </div>
  );
}
